export default __webpack_public_path__ + "static/media/airstrapz-blk-banner-3.38e7bc7e.jpg";